import React from "react";
import {
  Content,
  IconContainer,
  StepContainer,
  StepIcon,
  TrackLine,
} from "./styles";
import { Checkmark12Filled } from "@fluentui/react-icons";

interface StepProps {
  currentStep: number;
  stepNumber: number;
}

const Step: React.FC<StepProps> = ({ currentStep, stepNumber, children }) => {
  var iconClasses = "";
  var leftLineClasses = "";
  var rightLineClasses = "";

  if (stepNumber < 2) {
    leftLineClasses = leftLineClasses + " hidden";
  }

  if (stepNumber > 3) {
    rightLineClasses = rightLineClasses + " hidden";
  }

  if (currentStep > stepNumber) {
    iconClasses += " active-step";
    rightLineClasses += " active-line";
    leftLineClasses += " active-line";
  }

  if (currentStep == stepNumber) {
    iconClasses += " current-step";
    leftLineClasses += " active-line";
  }

  if (currentStep === 4) {
    iconClasses += " active-step";
  }

  return (
    <StepContainer>
      <IconContainer>
        <TrackLine className={leftLineClasses} />

        <StepIcon className={iconClasses}>
          {currentStep > stepNumber || currentStep === 4 ? <Checkmark12Filled /> : stepNumber}
        </StepIcon>

        <TrackLine className={rightLineClasses} />
      </IconContainer>
      <Content>{children}</Content>
    </StepContainer>
  );
};

export default Step;
